import React from 'react';

const Resume = () => {
    return (
        <section className="ftco-section ftco-no-pb" id="resume-section">
            <div className="container">
                <div className="row justify-content-center pb-5">
                    <div className="col-md-10 heading-section text-center" data-aos="fade-up">
                        <h1 className="big big-2">Resume</h1>
                        <h2 className="mb-4">Resume</h2>
                        <p>Innovative and performance-driven Software Engineer with advanced expertise in PHP, Laravel, and modern web technologies. Successfully led and delivered 30+ production-grade applications, integrating complex APIs and real-time features. Passionate about scalable architecture, optimized backend systems, and creating seamless digital experiences.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="resume-wrap ftco-animate" data-aos="fade-up">
                            <span className="date">2012-2014</span>
                            <h2>Secondary School | CBSE Board</h2>
                            <span className="position">I.S Dev Samaj Sr. Sec School, Chandigarh</span>
                            <p className="mt-4">Completed secondary school education under the CBSE board.</p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="100">
                            <span className="date">2016–2018</span>
                            <h2>Bachelor of Arts (IT)</h2>
                            <span className="position">Sri Guru Gobind Singh College, Chandigarh</span>
                            <p className="mt-4">Discontinued in the final year due to personal reasons. Later completed Bachelor of Computer Applications in 2024.</p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="200">
                            <span className="date">2020-2021</span>
                            <h2>PHP Internship</h2>
                            <span className="position">Omninos, Mohali, Punjab</span>
                            <p className="mt-4">Gained hands-on experience in PHP development during a professional internship and worked on 5 live projects.</p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="300">
                            <span className="date">2021-2024</span>
                            <h2>Bachelor of Computer Application</h2>
                            <span className="position">Swami Vivekanand Subharti University, Chandigarh</span>
                            <p className="mt-4">Completed Bachelor of Computer Application with a focus on software development and computer science fundamentals.</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="400">
                            <span className="date">2014-2016</span>
                            <h2>Higher Secondary | CBSE Board</h2>
                            <span className="position">I.S Dev Samaj Sr. Sec School, Chandigarh</span>
                            <p className="mt-4">Completed higher secondary education under the CBSE board.</p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="500">
                            <span className="date">2018-2019</span>
                            <h2>PHP Course (Web designing)</h2>
                            <span className="position">NICT, Sector 30, Chandigarh</span>
                            <p className="mt-4">Completed training in Core PHP/HTML/CSS with frontend and backend development, developed 5+ projects.</p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="600">
                            <span className="date">2021-2022</span>
                            <h2>Jr. PHP Developer</h2>
                            <span className="position">Seraphic</span>
                            <p className="mt-4">
                                Developed 10 projects. Contributed to PHP web app development, specializing in Laravel, including work on Bagiso Laravel e-commerce projects.
                            </p>
                        </div>
                        <div className="resume-wrap ftco-animate" data-aos="fade-up" data-aos-delay="700">
                            <span className="date">2022-Present</span>
                            <h2>Sr. Software Engineer PHP</h2>
                            <span className="position">Netscape Labs Pvt Ltd</span>
                            <p className="mt-4">
                                Developed 20+ projects. Experienced in Laravel & CodeIgniter, integrated Stripe API, and implemented real-time chat with Socket.io.
                            </p>
                        </div>
                    </div>
                </div>
                {/* <div className="row justify-content-center mt-5">
                    <div className="col-md-6 text-center" data-aos="fade-up">
                        <p><a href="#" className="btn btn-primary py-4 px-5">Download CV</a></p>
                    </div>
                </div> */}
            </div>
        </section>
    );
};

export default Resume;
